module.exports = __webpack_public_path__ + "static/img/1111-success.c12c6c8b.png";